import {CookieUtils} from '../../../../common/utils';
import {StorageHolder} from "../../../../common/core/storage/StorageHolder";

export class CookiesManager {

    private static TOKEN_EXPIRES = 'BS-Token-Lifetime';
    private static TOKEN_COOKIE = 'BS-Auth-Token';
    private static DESTINATION_URL_COOKIE = 'BS-Destination-URL';

    static isTokenExist(): boolean {
        return CookieUtils.check(CookiesManager.TOKEN_COOKIE);
    }

    static getToken(): string {
        return CookieUtils.get(CookiesManager.TOKEN_COOKIE);
    }

    static getTokenExpireMinutes(): number {
        return JSON.parse(StorageHolder.localStorage.getItem(CookiesManager.TOKEN_EXPIRES));
    }

    static setToken(token: string, expires?: number) {
        if (expires) {
            StorageHolder.localStorage.setItem(CookiesManager.TOKEN_EXPIRES, JSON.stringify(expires));
        }
        CookieUtils.set(CookiesManager.TOKEN_COOKIE, token, CookiesManager.getTokenExpireDate());
    }

    static clearToken() {
        CookieUtils.remove(CookiesManager.TOKEN_COOKIE);
    }

    static isDestinationURLExists() {
        return CookieUtils.check(CookiesManager.DESTINATION_URL_COOKIE);
    }

    static getDestinationURL(): string {
        return CookieUtils.get(CookiesManager.DESTINATION_URL_COOKIE);
    }

    static setDestinationURL(url: string) {
        CookieUtils.set(CookiesManager.DESTINATION_URL_COOKIE, url);
    }

    static clearDestinationURL() {
        CookieUtils.remove(CookiesManager.DESTINATION_URL_COOKIE);
    }

    private static getTokenExpireDate(): Date {
        return new Date(new Date().getTime() + CookiesManager.getTokenExpireMinutes() * 1000 * 60);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/cookies/cookies.manager.ts